"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isiOS = exports.isSafari = exports.iOSSafari = void 0;
var _userflow = require("./userflow");
var iOSSafari = exports.iOSSafari = function iOSSafari(_window) {
  if (typeof window === 'undefined' || !window) return false;
  var ua = (_window = window) === null || _window === void 0 ? void 0 : _window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  var webkit = !!ua.match(/WebKit/i);
  return iOS && webkit && !ua.match(/CriOS/i);
}();
var isSafari = exports.isSafari = function () {
  if (_userflow.isSSR) return false;
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}();

/**
 * Проверяем на IOS
 * @see https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
 */
var isiOS = exports.isiOS = function () {
  try {
    if (typeof window === 'undefined' || !window) {
      return false;
    }
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    navigator.userAgent.includes('Mac') && 'ontouchend' in document;
  } catch (err) {
    return false;
  }
}();